import React from 'react'
import { TelephoneFill } from 'react-bootstrap-icons'
import { Button, Col, Row } from 'reactstrap'

export const Header = () => {
  return (
    <div id='website-responsive'>
        <div className='pt-3 pb-2' style={{ borderBottom:'3px solid #ea1f25'}}>
            <Row className=''>
                <Col className=''>
                    <div className='ps-md-3 ps-2'>
                        <img src='logo/United-Lab-Care-Logo-1536x281.png' alt='logo' height='auto' width='' className='img-w20' />
                    </div>
                </Col>
                <Col className=''>
                <div  className='grid-flex-center me-md-5 me-1'>
                <div className='mb-md-0 mb-3'>
                    <a href='tel: +205 625-3332' style={{ textDecoration:'none' }}>
                    <TelephoneFill className='text-ss-primary fs-ss-20'/>
                    <text className='px-2 border- border2 me-3 fw-600 text-montserrat fs-ss-18' style={{ color:'black', fontSize:'', }}> (800) 442-1663 </text>
                    </a>
                </div>
                    <Button className='btn-ss-secondary rounded20 flex-center ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)', display:'flex'}}>
                        <text className='text-montserrat fw-700 fs-ss-14' style={{ padding:'',}}>
                            Book Blood Test Now
                        </text>
                </Button>
                    </div>
                </Col>
            </Row>
        </div>
    </div>
  )
}
